import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45012044"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  key: 0,
  class: "linkard-config-tost"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "content-wrapper" }
const _hoisted_5 = { class: "header-link" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("label", null, "LINKARD")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_8 = { class: "card-collect-main" }
const _hoisted_9 = { class: "left_action_button" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "我的联卡", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "我的卡包", -1))
const _hoisted_12 = { class: "right_action_button" }
const _hoisted_13 = ["src"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "卡柜", -1))
const _hoisted_15 = { class: "bottom_info_bg" }
const _hoisted_16 = { class: "bar-con" }
const _hoisted_17 = {
  key: 0,
  class: "talk-input"
}
const _hoisted_18 = { class: "welcome_msg" }
const _hoisted_19 = { class: "adver-chat-main" }
const _hoisted_20 = { class: "adver-box" }
const _hoisted_21 = { class: "content-middle" }
const _hoisted_22 = { class: "middle-bg" }
const _hoisted_23 = { href: "javascript:;" }
const _hoisted_24 = ["src"]
const _hoisted_25 = { class: "middle-content" }
const _hoisted_26 = { class: "title" }
const _hoisted_27 = { class: "btn-wrapper" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "social-media-text" }, "社媒聚合页", -1))
const _hoisted_29 = {
  key: 0,
  class: "social_links_new"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "social-media-icon" }, null, -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "social-media-new" }, "NEW", -1))
const _hoisted_32 = [
  _hoisted_30,
  _hoisted_31
]
const _hoisted_33 = { class: "space-box-3d" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_ChatLottie = _resolveComponent("ChatLottie")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_MediaList = _resolveComponent("MediaList")!
  const _component_ChatMessageList = _resolveComponent("ChatMessageList")!
  const _component_MyEvaluationList = _resolveComponent("MyEvaluationList")!
  const _component_EvaluationDetailView = _resolveComponent("EvaluationDetailView")!
  const _component_Chat = _resolveComponent("Chat")!
  const _component_MyFavoritesComponent = _resolveComponent("MyFavoritesComponent")!
  const _component_MyLinkardListView = _resolveComponent("MyLinkardListView")!
  const _component_LeaveMessage = _resolveComponent("LeaveMessage")!
  const _component_Cabinet = _resolveComponent("Cabinet")!
  const _component_EmptyCardComponent = _resolveComponent("EmptyCardComponent")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", {
      class: "home-container",
      style: _normalizeStyle({ backgroundImage: `url(${_ctx.backgroundImg})` })
    }, [
      (_ctx.isMySelfPath)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, " 如需配置您的联卡，请使用电脑前往 www.linkard.me 开始配置 "))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.sourceType == 1
        ? 'unity-iframe-container-minimalism'
        : 'unity-iframe-container'
        )
      }, [
        _createElementVNode("iframe", {
          id: "my-iframe",
          class: "unity-iframe",
          src: _ctx.isHarmonyos ? _ctx.LOCAL_UNITY_HM_URL_PATH : _ctx.LOCAL_UNITY_URL_PATH,
          width: "100%",
          height: "100%",
          ref: "unityIframe"
        }, null, 8, _hoisted_3)
      ], 2),
      _withDirectives(_createElementVNode("div", {
        class: _normalizeClass(['content', _ctx.isMySelfPath ? 'content-pt0' : ''])
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _hoisted_7,
            _createElementVNode("span", null, "linkard.me/" + _toDisplayString(_ctx.path), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              (!_ctx.$route.query.preview)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "home-card-top-action-box",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toMyLinkard && _ctx.toMyLinkard(...args)))
                  }, [
                    _createVNode(_component_van_image, {
                      src: require('../assets/image/icon-card.png')
                    }, null, 8, ["src"]),
                    _hoisted_10
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.$route.query.preview)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "home-card-top-action-box card_box",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toMyFavorites && _ctx.toMyFavorites(...args)))
                  }, [
                    _createVNode(_component_van_image, {
                      src: require('../assets/image/icon-card.png')
                    }, null, 8, ["src"]),
                    _hoisted_11
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _withDirectives(_createElementVNode("div", {
                class: "collect-box ta-click-collect",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleCollect && _ctx.handleCollect(...args)))
              }, " 收藏 ", 512), [
                [_vShow, !_ctx.$route.query.preview && !_ctx.isMySelfPath && !_ctx.favoriteStatus
                ]
              ]),
              _withDirectives(_createElementVNode("div", {
                class: "collect-box had-collect ta-click-cancel-collect",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleCancelCollect && _ctx.handleCancelCollect(...args)))
              }, " 已收藏 ", 512), [
                [_vShow, !_ctx.$route.query.preview && !_ctx.isMySelfPath && _ctx.favoriteStatus
                ]
              ]),
              (_ctx.cabinetValid && !_ctx.$route.query.preview)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "cabinet_box",
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toMyCabinet && _ctx.toMyCabinet(...args)))
                  }, [
                    _createElementVNode("img", {
                      src: require('../assets/image/cabinet_box_icon.svg')
                    }, null, 8, _hoisted_13),
                    _hoisted_14
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ], 2), [
        [_vShow, !_ctx.showChat && _ctx.sourceType == 0]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (_ctx.showWelcomeMsg)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.welcomeMsg), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            (!_ctx.isOwn && _ctx.userPhone)
              ? (_openBlock(), _createBlock(_component_van_button, {
                  key: 0,
                  class: "adver-box-item",
                  onClick: _ctx.phoneCall
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 电话 ")
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true),
            ((!_ctx.isOwn && _ctx.messageValid) || _ctx.isOwn)
              ? (_openBlock(), _createBlock(_component_van_button, {
                  key: 1,
                  class: "adver-box-item",
                  onClick: _ctx.toLeaveMessage
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.isOwn ? "查看留言" : "留言"), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_ChatLottie, {
            ref: "chatLottie",
            class: "chat-box ta-click-to-chat",
            onClick: _ctx.toChat,
            autoPlay: true,
            title: "自由对话"
          }, null, 8, ["onClick"])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("a", _hoisted_23, [
              _createElementVNode("img", {
                class: "logo_img",
                src: _ctx.companyLogo || require('../assets/image/linkard_logo.png')
                
              }, null, 8, _hoisted_24)
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.linkardName), 1),
              _createElementVNode("div", _hoisted_27, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.linkardTags || [], (item, index) => {
                  return (_openBlock(), _createElementBlock("span", { key: index }, _toDisplayString(item), 1))
                }), 128))
              ]),
              _createElementVNode("div", {
                class: "social-media-box",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.showMediaClick && _ctx.showMediaClick(...args)))
              }, [
                _hoisted_28,
                (_ctx.showSocialLinksNew)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, _hoisted_32))
                  : _createCommentVNode("", true),
                _createVNode(_component_van_icon, {
                  size: _ctx.$route.query.preview ? '10' : '30',
                  style: {"margin-left":"4px"},
                  name: require('../assets/image/social_media_arrow.svg')
                }, null, 8, ["size", "name"])
              ])
            ])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(['space-box', _ctx.spaceValid ? '' : 'no-space-box']),
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleSpaceVisit && _ctx.handleSpaceVisit(...args)))
          }, [
            _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.linkardId ? _ctx.spaceName : "暂未创建数字空间"), 1),
            _createVNode(_component_van_image, {
              src: _ctx.spaceValid
              ? require('../assets/image/has_space_icon.svg')
              : require('../assets/image/no_space_icon.svg')
              
            }, null, 8, ["src"])
          ], 2)
        ])
      ], 512), [
        [_vShow, !_ctx.showChat]
      ]),
      (_ctx.showMedia)
        ? (_openBlock(), _createBlock(_component_MediaList, {
            key: 1,
            linkardId: _ctx.linkardId,
            linksList: _ctx.previewMediaList,
            onCloseMedia: _ctx.closeMediaDialog
          }, null, 8, ["linkardId", "linksList", "onCloseMedia"]))
        : _createCommentVNode("", true),
      (_ctx.showChatMessageList)
        ? (_openBlock(), _createBlock(_component_ChatMessageList, {
            key: 2,
            linkardId: _ctx.linkardId,
            npcName: _ctx.currentLKInfo?.npc.npcName,
            sourceType: _ctx.sourceType,
            onCloseChatMessageListView: _ctx.closeChatMessageListView
          }, null, 8, ["linkardId", "npcName", "sourceType", "onCloseChatMessageListView"]))
        : _createCommentVNode("", true),
      (_ctx.showMyEvaluationList)
        ? (_openBlock(), _createBlock(_component_MyEvaluationList, {
            key: 3,
            linkardId: _ctx.linkardId,
            onCloseMyEvaluationListView: _ctx.closeMyEvaluationListView,
            onShowEvaluationDetailView: _ctx.showEvaluationDetailView
          }, null, 8, ["linkardId", "onCloseMyEvaluationListView", "onShowEvaluationDetailView"]))
        : _createCommentVNode("", true),
      (_ctx.showEvaluationDetail)
        ? (_openBlock(), _createBlock(_component_EvaluationDetailView, {
            key: 4,
            evalReportId: _ctx.evalReportId,
            onCloseEvaluationDetailView: _ctx.closeEvaluationDetailView
          }, null, 8, ["evalReportId", "onCloseEvaluationDetailView"]))
        : _createCommentVNode("", true),
      _withDirectives(_createVNode(_component_Chat, {
        ref: "chatViewRef",
        linkardId: _ctx.linkardId,
        showChat: _ctx.showChat,
        sdkToken: _ctx.sdkToken,
        micPermissions: _ctx.micPermissions,
        hasInitService: _ctx.hasInitService,
        initUnityCallBack: _ctx.initUnityCallBack,
        sourceType: _ctx.sourceType,
        npcName: _ctx.currentLKInfo?.npc.npcName,
        scaleValid: _ctx.currentLKInfo?.scaleValid,
        greetingMsg: _ctx.currentLKInfo?.npc.greetingMsg,
        scaleIconText: _ctx.currentLKInfo?.scaleIconText,
        chatSceneIconText: _ctx.currentLKInfo?.chatSceneIconText,
        storyIconText: _ctx.currentLKInfo?.storyIconText,
        chatMenuList: _ctx.currentLKInfo?.chatMenuList,
        reviewBookId: _ctx.reviewBookId,
        reviewCourseId: _ctx.reviewCourseId,
        onCloseChatView: _ctx.closeChatView,
        onStartCaptureAudioMethod: _ctx.startCaptureAudioMethod,
        onStopCaptureAudioMethod: _ctx.stopCaptureAudioMethod,
        onInterruptPlayVoiceMethod: _ctx.interruptPlayVoiceMethod,
        onSetSendAudioEnableMethod: _ctx.setSendAudioEnableMethod,
        onGetMicPermissions: _ctx.getMicPermissions,
        onShowChatMessageListMethod: _ctx.showChatMessageListMethod,
        onShowMyEvaluationListMethod: _ctx.showMyEvaluationListMethod,
        onSendTextToMouthCallBackMethod: _ctx.sendTextToMouthCallBackMethod,
        onShowEvaluationDetailView: _ctx.showEvaluationDetailView,
        onResetRegisterSetChatParam: _ctx.resetRegisterSetChatParam
      }, null, 8, ["linkardId", "showChat", "sdkToken", "micPermissions", "hasInitService", "initUnityCallBack", "sourceType", "npcName", "scaleValid", "greetingMsg", "scaleIconText", "chatSceneIconText", "storyIconText", "chatMenuList", "reviewBookId", "reviewCourseId", "onCloseChatView", "onStartCaptureAudioMethod", "onStopCaptureAudioMethod", "onInterruptPlayVoiceMethod", "onSetSendAudioEnableMethod", "onGetMicPermissions", "onShowChatMessageListMethod", "onShowMyEvaluationListMethod", "onSendTextToMouthCallBackMethod", "onShowEvaluationDetailView", "onResetRegisterSetChatParam"]), [
        [_vShow, _ctx.showChat]
      ])
    ], 4), [
      [_vShow, !_ctx.showFavorites &&
      !_ctx.showCabinet &&
      !_ctx.showMessageBoardView &&
      !_ctx.showEmptyCard
      ]
    ]),
    (_ctx.showFavorites && !_ctx.$route.query.preview)
      ? (_openBlock(), _createBlock(_component_MyFavoritesComponent, {
          key: 0,
          onClose: _ctx.closeMyFavorites
        }, null, 8, ["onClose"]))
      : _createCommentVNode("", true),
    (_ctx.showMyLinkardListView && !_ctx.$route.query.preview)
      ? (_openBlock(), _createBlock(_component_MyLinkardListView, {
          key: 1,
          onClose: _ctx.closeMyLinkardListView
        }, null, 8, ["onClose"]))
      : _createCommentVNode("", true),
    (_ctx.showMessageBoardView && !_ctx.$route.query.preview)
      ? (_openBlock(), _createBlock(_component_LeaveMessage, {
          key: 2,
          onCloseLeaveMessage: _ctx.closeLeaveMessage,
          onGoToPathFromMessageBoard: _ctx.goToPathFromMessageBoard,
          linkardId: _ctx.linkardId,
          isOwn: _ctx.isOwn
        }, null, 8, ["onCloseLeaveMessage", "onGoToPathFromMessageBoard", "linkardId", "isOwn"]))
      : _createCommentVNode("", true),
    (_ctx.showCabinet)
      ? (_openBlock(), _createBlock(_component_Cabinet, {
          key: 3,
          linkardId: _ctx.linkardId,
          cabinetUserId: _ctx.cabinetUserId,
          cabinetId: _ctx.cabinetId,
          onClose: _ctx.closeCabinet
        }, null, 8, ["linkardId", "cabinetUserId", "cabinetId", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.showEmptyCard && _ctx.dataLoaded && !_ctx.$route.query.preview)
      ? (_openBlock(), _createBlock(_component_EmptyCardComponent, {
          key: 4,
          isMySelf: _ctx.isMySelfPath,
          onToMyLinkard: _ctx.toMyLinkard,
          onToMyFavorites: _ctx.toMyFavorites
        }, null, 8, ["isMySelf", "onToMyLinkard", "onToMyFavorites"]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode(_component_Loading, null, null, 512), [
      [_vShow, !_ctx.dataLoaded]
    ])
  ]))
}